import Vision from "@/components/Vision";

export default function VisionPage() {
  return (
    <div className="pt-16 lg:pt-20" data-testid="vision-page">
      <Vision />
    </div>
  );
}
